import { Stack } from '@mui/material';

import { Error } from '../../../../feedback/errors/error/error';

/** @experimental In active development. */
export const GridErrorOverlay = () => {
  return (
    <Stack sx={{ height: '100%' }}>
      <Error />
    </Stack>
  );
};
